<div *ngIf="value">
  <div class="label">{{ label }}</div>
  <div class="value">{{ value }}</div>
</div>
